import starSvg from '@listening/assets/astro/images/star.svg';
import UniversityBanner from '@/components/astro/new-design-25/Homepage/UniversityBanner';
import * as m from '@/paraglide/messages';
import { AccentText } from '../accent-text';
import { voicePortrait } from '../voice-portrait';
import { ReaderDemo } from './reader-demo';
import { CtaButton } from './subcomponents/cta-button';

export function SqueezeHero({ onCta }: { onCta: () => void }) {
  return (
    <div className='bg-gradient-to-b from-white via-mist-385 to-white'>
      <div className='mx-auto grid max-w-[1220px] grid-cols-1 items-center gap-8 px-4 pt-9 pb-6 sm:px-7 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-10 lg:pt-13'>
        <div className='text-center lg:text-left'>
          <span className='inline-flex items-center gap-1.5 rounded-full bg-mist-605 px-3.5 py-1.5 text-[13.5px] font-semibold text-azure-455'>
            🎓 {m.funnel_sq_chip()}
          </span>
          <h1 className='mt-4 mb-4 text-[34px] leading-[1.07] font-extrabold tracking-tight text-balance lg:text-[42px]'>
            <AccentText className='text-azure-595' text={m.funnel_sq_h1()} />
          </h1>
          <CtaButton className='px-7 py-4 text-[17px]' onClick={onCta} />
          <div className='mt-6 flex items-center justify-center gap-3.5 lg:justify-start'>
            <div className='flex -space-x-[11px]'>
              <VoiceAvatar name='Scarlett' />
              <VoiceAvatar name='Justin' />
              <VoiceAvatar name='Amy' />
              <VoiceAvatar name='Hugh' />
              <VoiceAvatar name='Will' />
            </div>
            <div className='flex flex-col items-start text-left leading-tight'>
              <span className='flex items-center gap-1.5 text-[15px] font-extrabold'>
                <span className='flex'>
                  <img alt='' className='size-3.5' src={starSvg} />
                  <img alt='' className='size-3.5' src={starSvg} />
                  <img alt='' className='size-3.5' src={starSvg} />
                  <img alt='' className='size-3.5' src={starSvg} />
                  <img alt='' className='size-3.5' src={starSvg} />
                </span>
                4.8
              </span>
              <small className='text-[12.5px] text-steel-700'>
                {m.funnel_sq_rating_reviews()}
              </small>
            </div>
          </div>
        </div>
        <ReaderDemo variant='research' />
      </div>

      <div className='mt-1.5 border-t border-steel-120 pt-1 pb-2'>
        <UniversityBanner />
      </div>
    </div>
  );
}

function VoiceAvatar({ name }: { name: Parameters<typeof voicePortrait>[0] }) {
  return (
    <img
      alt=''
      className='size-[38px] rounded-full border-[2.5px] border-white object-cover shadow-sm'
      src={voicePortrait(name)}
    />
  );
}
